export const translation = {
  sv: {
    lang: {
      numericSymbols: [null, ' miljoner', ' miljarder', ' biljoner', null, null],
      weekdays: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'],
      months: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'],
      shortMonths: ['jan', 'febr', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sept', 'okt', 'nov', 'dec'],
      thousandsSep: '\xa0',
      decimalPoint: ',',
    },
    xAxis: {
      dateTimeLabelFormats: {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%e %b',
        week: '%e %b',
        month: '%b -%y',
        year: '%Y',
      },
    },
  },
  fi: {
    lang: {
      numericSymbols: null,
      weekdays: ['sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai'],
      shortWeekdays: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
      months: ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskyy', 'lokakuu', 'marraskuu', 'joulukuu'],
      shortMonths: ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskyy', 'lokakuu', 'marraskuu', 'joulukuu'],
      thousandsSep: '\xa0',
      decimalPoint: ',',
    },
    xAxis: {
      dateTimeLabelFormats: {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%e.%o.',
        week: '%e.%o.',
        month: '%b -%y',
        year: '%Y',
      },
    },
  },
}
